module.exports = __webpack_public_path__ + "static/luster-9e4e768ffd20a332d47a4f788b1b343a.png";